import { MessageSeverityEnum } from "../_common/enum/messageSeverity.enum";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "auctionMessage";

export const auctionMessageService = {
    getAll,
    post,
    disable
};

function getAll(auctionId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?auctionId=${auctionId}`, requestOptions).then(handleResponse);
}

function post(auctionId: number, catalogueId: number, message: string, messageSeverityId?: MessageSeverityEnum | null, catalogueUserId?: number | null) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody({ auctionId: auctionId, catalogueId: catalogueId, message: message, messageSeverityId: messageSeverityId, catalogueUserId: catalogueUserId }) };
    return fetch(`${API_URL}/${API_NAME}/create`, requestOptions).then(handleResponse);
}

function disable(id: any) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/disable/?id=${id}`, requestOptions).then(handleResponse);
}